import { render, staticRenderFns } from "./OrdersMainList.vue?vue&type=template&id=078bc0c9&"
import script from "./OrdersMainList.vue?vue&type=script&lang=js&"
export * from "./OrdersMainList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports